// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setPreviewSecurities = createAction('[Custom PDF Report Builder] Set Preview Securities', props());
export const setPreviewSecurityNamingConvention = createAction('[Custom PDF Report Builder] Set Preview Naming Convention', props());
